<template>
  <div class="max-w-7xl mx-auto sm:px-2 lg:px-8 pb-12">
    <div class="text-center">
      <h2
        class="text-2xl tracking-wide leading-10 font-extrabold font-open-sans text-white mt-4 sm:text-5xl sm:leading-none md:text-4xl"
      >
        Meet the Team
      </h2>
      <div class="mt-6">
        <video controls class="w-full">
          <source
            src="https://firebasestorage.googleapis.com/v0/b/usergroupmeeting-2021-1c57f.appspot.com/o/public%2FMEET-THE-TEAM-2021-V1.mp4?alt=media&token=41e97b0b-b2d9-4227-a24d-e6064b47b706"
          />
        </video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Team"
};
</script>

<style scoped></style>
